import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    supplier: null,
    suppliers: [],
  },

  getters: {
    supplier(state) {
      return state.supplier
    },
    suppliers(state) {
      return state.suppliers
    },
  },

  mutations: {
    SET_SUPPLIER(state, value) {
      state.supplier = value
    },
    SET_SUPPLIERS(state, value) {
      state.suppliers = value
    },
    UPDATE_SUPPLIER(state, data) {
      const index = state.suppliers.findIndex((item) => item.id == data.id)
      if (index >= 0) {
        Object.assign(state.suppliers[index], data)
      }
    },
    ADD_SUPPLIER(state, data) {
      state.suppliers.unshift(data)
    },
    DELETE_SUPPLIER(state, id) {
      const index = state.suppliers.findIndex((item) => String(item.id) === String(id))
      if (index !== -1) {
        state.suppliers.splice(index, 1)
      }
    },
  },

  actions: {
    async loadSupplier({ commit }, supplierId) {
      const response = await axios.get(`api/suppliers/${supplierId}`)
      commit('SET_SUPPLIER', response.data)
      return response.data
    },
    loadSuppliers({ commit }) {
      return axios.get('api/suppliers').then((response) => {
        commit('SET_SUPPLIERS', response.data.data)
      })
    },
    updateSupplier({ commit }, { formData }) {
      return axios
        .post(`api/suppliers/${formData.get('id')}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const data = response.data.data ?? response.data
          commit('UPDATE_SUPPLIER', data)
        })
    },
    searchSuppliers(_, keyword) {
      return axios
        .post('api/suppliers/search', { keyword })
        .then((response) => response.data.data || [])
    },
    addSupplier({ commit }, { formData }) {
      return axios
        .post('api/suppliers', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          const data = response.data.data ?? response.data
          commit('ADD_SUPPLIER', data)
        })
    },
    deleteSupplier({ commit }, id) {
      return axios.delete(`api/suppliers/${id}`).then(() => {
        commit('DELETE_SUPPLIER', id)
      })
    },
  },
}
